import React from 'react'
import { Link } from 'react-router-dom'
import { Nav, Navbar, NavItem, NavbarBrand, Container } from 'reactstrap'
const Heading = () => {
    return (
        <Navbar color='dark' dark>
            <Container>
                <NavbarBrand href='/'>My Team</NavbarBrand>
                <Nav>
                    <NavItem>
                        <Link to='/add' className='btn btn-primary'>Add User</Link>
                    </NavItem>
                </Nav>
            </Container>
        </Navbar>
    )
}

export default Heading



// WEBPACK FOOTER //
// ./src/components/Heading.js